var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabIconMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 31.742 45.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7343",
    "data-name": "Group 7343",
    transform: "translate(-76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7344",
    "data-name": "Group 7344",
    transform: "translate(76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7343-2",
    "data-name": "Group 7343",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22664",
    "data-name": "Path 22664",
    d: "M91.871,0a15.874,15.874,0,0,0-13.5,24.217l12.6,20.3a1.323,1.323,0,0,0,1.124.625h.01a1.322,1.322,0,0,0,1.124-.643L105.5,24A15.874,15.874,0,0,0,91.871,0Zm11.362,22.644L92.071,41.281,80.617,22.823a13.235,13.235,0,1,1,22.616-.179Z",
    transform: "translate(-76)",
    fill: "#9797bd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7346",
    "data-name": "Group 7346",
    transform: "translate(83.935 7.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7345",
    "data-name": "Group 7345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22665",
    "data-name": "Path 22665",
    d: "M173.935,90a7.935,7.935,0,1,0,7.935,7.935A7.944,7.944,0,0,0,173.935,90Zm0,13.243a5.308,5.308,0,1,1,5.3-5.308A5.312,5.312,0,0,1,173.935,103.243Z",
    transform: "translate(-166 -90)",
    fill: "#9797bd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIconMap);
export default __webpack_public_path__ + "static/media/TabIconMap.ab54257e2445c07b12e847f6318c0f23.svg";
export { ForwardRef as ReactComponent };